module.exports = __webpack_public_path__ + "img/earth.8c551f34.png";